import React from 'react';

import { selectIsCustomerUser } from 'store/User/selectors';
import { selectUxType } from 'store/UI/selectors';
import { useAppSelector } from 'store/hooks';
import { selectUserV2 } from 'store/v2/User/selectors';
import { isTenantAdminUser } from 'store/v2/User/utils';

import CustomerBanner from './CustomerBanner';
import TenantBanner from './TenantBanner';
import TenantFailedPaymentBanner from './TenantFailedPaymentBanner';
import TenantWorkOrderActionRequiredBanner from './TenantWorkOrderActionRequiredBanner';

interface Props {}

const CustomerBanners: React.FC<Props> = () => {
  const uxType = useAppSelector(selectUxType);
  const userV2 = useAppSelector(selectUserV2);
  const isCustomerUser = useAppSelector(selectIsCustomerUser);
  const isTenantUx = uxType === 'tenant';
  const isTenantAdmin = !!(userV2 && isTenantUx && isTenantAdminUser(userV2));
  const isCustomerUx = uxType === 'customer';

  return (
    <>
      {isTenantUx && isTenantAdmin && <TenantBanner />}
      {isTenantUx && isTenantAdmin && <TenantWorkOrderActionRequiredBanner />}
      {isTenantUx && isTenantAdmin && <TenantFailedPaymentBanner />}
      {isCustomerUx && isCustomerUser && <CustomerBanner />}
    </>
  );
};

export default CustomerBanners;
